/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Adjustsubmit2Inputs */

const zh_adminsubs_adjustsubmit2 = /** @type {(inputs: Adminsubs_Adjustsubmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认调整`)
};

const en_adminsubs_adjustsubmit2 = /** @type {(inputs: Adminsubs_Adjustsubmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm`)
};

const es_adminsubs_adjustsubmit2 = /** @type {(inputs: Adminsubs_Adjustsubmit2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar`)
};

/**
* | output |
* | --- |
* | "Confirm" |
*
* @param {Adminsubs_Adjustsubmit2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_adjustsubmit2 = /** @type {((inputs?: Adminsubs_Adjustsubmit2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Adjustsubmit2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_adjustsubmit2(inputs)
	if (locale === "en") return en_adminsubs_adjustsubmit2(inputs)
	return es_adminsubs_adjustsubmit2(inputs)
});
export { adminsubs_adjustsubmit2 as "adminSubs_adjustSubmit" }